/**
 * Chat event bus — decouples chat streaming from plugins (voice TTS, etc.).
 *
 * ChatRuntimeWrapper dispatches events here. Any component can subscribe
 * without the chat code knowing about it.
 *
 * Events:
 *   - 'tts_audio'      detail: { data: string (base64 audio) }
 *   - 'tts_done'       detail: {}
 *   - 'user_message'   detail: {}  (user sent a message)
 */
const chatEvents = new EventTarget();
export default chatEvents;
